<div>
    <div class="col-sm-12" *ngIf="title">
        <label class="title"> {{ title }} </label>
    </div>
    <div class="col-sm-12">
        <div *ngIf="spinnerShow" class="spinner">
            <app-input-spinner [color]="'purple'" [showSpinner]="true"></app-input-spinner>
        </div>

        <mat-form-field *ngIf="selectShow" [ngClass]="formFieldClass">
            <mat-label *ngIf="selectPlaceholder">{{ selectPlaceholder }}</mat-label>
            <mat-select
                [(ngModel)]="selectSelected"
                (ngModelChange)="onSelectModelChange($event)"
                [compareWith]="selectCompare"
                [disabled]="isSelectDisabled"
                [multiple]="selectMultiple"
                [panelClass]="selectPanelClass"
            >
                <ng-template ngFor let-option [ngForOf]="selectOptions" [ngForTrackBy]="trackByOption">
                    <mat-option *ngIf="option.useInnerHTML" [value]="option.value"> <span [innerHtml]="option.label"> </span></mat-option>
                    <mat-option *ngIf="!option.useInnerHTML" [value]="option.value">{{ option.label }}</mat-option>
                </ng-template>
            </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="selectShowDisabled" [ngClass]="formFieldClass">
            <mat-label *ngIf="selectPlaceholder">{{ selectPlaceholder }}</mat-label>
            <mat-select [disabled]="true"> </mat-select>
        </mat-form-field>
        <ng-template *ngIf="formFieldSiblings" [ngTemplateOutlet]="formFieldSiblings" [ngTemplateOutletContext]="{}"> </ng-template>
    </div>
</div>
